import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation UpdateCourseGroup($id: Int!) {
    deleteCourseGroup(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteCourseGroup: {
    id?: number;
  };
}
